var esusCommon = {
    verificaObrigatoriedadeEquipe: function (idUps, idProfissional, idCbo) {
        var retorno = null;

        $.ajax({
            url: '/cadastro/upsequipe/getequipeporcboupsprofissional',
            data: {
                id_ups: idUps,
                id_profissional: idProfissional,
                id_cbo: idCbo
            },
            type: 'get',
            dataType: 'json',
            async: false,
            success: function (data) {
                retorno = data;
            }
        });

        return retorno;
    },
    verificaObrigatoriedadeEquipeExcetoTiposEquipe: function (idUps, idProfissional, idCbo, tiposEquipe) {
        var retorno = null;

        $.ajax({
            url: `/cadastro/upsequipe/getequipeporcboupsprofissional`,
            data: {
                id_ups: idUps,
                id_profissional: idProfissional,
                id_cbo: idCbo,
                tipos_equipe_excluir: tiposEquipe
            },
            type: 'get',
            dataType: 'json',
            async: false,
            success: function (data) {
                retorno = data;
            }
        });

        return retorno;
    },
    obrigaDesobrigaFieldEquipe: function (idUps, idProfissional, idCbo, nameFieldEquipe) {
        setTimeout(function () {
            var dataEquipe = esusCommon.verificaObrigatoriedadeEquipe(idUps, idProfissional, idCbo);

            if (dataEquipe != undefined && dataEquipe.id_equipe) {
                if (!$('#' + nameFieldEquipe).val() && !$('#text_' + nameFieldEquipe).val()) {
                    $('#' + nameFieldEquipe).val(dataEquipe.id_equipe);
                    $('#text_' + nameFieldEquipe).val(dataEquipe.equipe);
                    $('#text_' + nameFieldEquipe).parent().siblings('label').addClass('required');
                    adicionaRemoveRequerido('#text_' + nameFieldEquipe + '-label label', true);
                }
            } else {
                $('#' + nameFieldEquipe).val('');
                $('#text_' + nameFieldEquipe).val('');
                $('#text_' + nameFieldEquipe).parent().siblings('label').removeClass('required');
                adicionaRemoveRequerido('#text_' + nameFieldEquipe + '-label label', false);
            }
        }, 500);
    }
};

var _esusLogController = null;
var _esusLogId = null;
var _esusLogTemAcesso = null;

function abreModalLogEsus(controller, id, temAcessoModalLote, validaAcesso = true) {
    _esusLogController = controller;
    _esusLogId = id;
    _esusLogTemAcesso = temAcessoModalLote;
    if(validaAcesso === false || temAcessoModalLote === true){
        new ModalSwal().abrir({
            url: '/' + controller + '?id=' + id,
            title: 'Lote de Envio - e-SUS',
            width: '80%',
            bBotaoConfirmar: false,
            bBotaoCancelar: false,
        });
    } else {
        Swal.fire({
            title: 'Erro',
            html: `
            <div style="color:#900">
                <br><br>Sem permissão para executar a ação.<br><br>
            </div>
                `,
            icon: 'error'
        });
        return;  
    }

}

function carregarVisualizacaoLogEsus(valorLinha, dadosLinha) {
    var itemId       = (dadosLinha && dadosLinha.idEsusExportacaoItem != null)    ? dadosLinha.idEsusExportacaoItem    : null;
    var esusLogTipo  = (dadosLinha && dadosLinha.esusLogEntityTipo != null)  ? dadosLinha.esusLogEntityTipo  : null;
    var esusLogId    = (dadosLinha && dadosLinha.esusLogEntityId != null)   ? dadosLinha.esusLogEntityId   : null;
    var data = {};
    if (itemId)      data.id_esus_exportacao_item = itemId;
    if (esusLogTipo) data.esus_log_entity_tipo    = esusLogTipo;
    if (esusLogId)   data.esus_log_entity_id      = esusLogId;
    $.ajax({
        url: '/cadastro/exportaesus/visualizarlogjsonmodal',
        data: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        success: function (html) {
            //Se já existe modal, altera o conteúdo (domicílio e paciente)
            if ($('.modal-swal-content').length) {
                $('.modal-swal-title').text('JSON');
                $('.modal-swal-content').html(html);
                renderizarJsonEsus('#esus-json-viewer', ($('#esus-json-raw').val() || '').trim());
                renderizarJsonEsus('#esus-log-viewer', ($('#esus-log-raw').val() || '').trim());
                $('.swal2-actions').show().html(
                    '<button class="swal2-styled btn-salvar" onclick="copiarJsonEsus()">COPIAR JSON</button>' +
                    '<button class="swal2-styled btn-cancelar" onclick="voltarModalLogEsus()">VOLTAR</button>'
                );
            } else {
                //Senão, cria a modal (fichas e-sus)
                new ModalSwal().abrir({
                    html: html,
                    title: 'JSON',
                    width: '80%',
                    bBotaoConfirmar: false,
                    bBotaoCancelar: false,
                    onReady: function () {
                        renderizarJsonEsus('#esus-json-viewer', ($('#esus-json-raw').val() || '').trim());
                        renderizarJsonEsus('#esus-log-viewer', ($('#esus-log-raw').val() || '').trim());
                        $('.swal2-actions').show().html(
                            '<button class="swal2-styled btn-salvar" onclick="copiarJsonEsus()">COPIAR JSON</button>' +
                            '<button class="swal2-styled btn-cancelar" onclick="Swal.close()">VOLTAR</button>'
                        );
                    }
                });
            }
        }
    });
}

function renderizarJsonEsus(campo, jsonStr) {
    if (!jsonStr){
        return;
    }

    $('<link>').attr({ rel: 'stylesheet', href: '/stylesheets/jquery.jsonview.css' }).appendTo('head');
    
    $.getScript('/js/jquery.jsonview.js', function () {
        $(campo).JSONView(jsonStr);
    });
}

function copiarJsonEsus() {
    var jsonRaw = document.getElementById('esus-json-raw');
    var logRaw  = document.getElementById('esus-log-raw');
    var valor   = (jsonRaw && jsonRaw.value) ? jsonRaw.value : (logRaw ? logRaw.value : '');
    navigator.clipboard.writeText(valor).catch(function () {});
}

function voltarModalLogEsus() {
    $.ajax({
        url: '/' + _esusLogController + '?id=' + _esusLogId,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        success: function(html) {
            $('.modal-swal-title').text('Lote de Envio - e-SUS');
            $('.modal-swal-content').html(html);
            $('.swal2-actions').hide();
        }
    });
}

function abrirModalLogMapaAtendimentoProcedimento(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalmapaatendimentoprocedimento',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogMapaAtendimentoOdonto(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalmapaatendimentoodonto',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogAtividadeColetiva(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalatividadecoletiva',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogAtendimentoDomiciliar(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalatendimentodomiciliar',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogVisitaDomiciliar(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalvisitadomiciliar',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogAvaliacaoElegibilidade(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalavaliacaoelegibilidade',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogZikaMicrocefalia(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalzikamicrocefalia',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogMarcadoresConsumoAlimentar(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalmarcadoresconsumoalimentar',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogAtendimentoIndividual(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalmapaatendimentoindividual',
        valorLinha,
        null,
        false
    );
}

function abrirModalLogCuidadoCompartilhado(valorLinha, dadosLinha) {
    abreModalLogEsus(
        'cadastro/exportaesus/visualizarlogmodalcuidadocompartilhado',
        valorLinha,
        null,
        false
    );
}